import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListEmpty from "../../components/ListEmpty";
import Loading from "../../components/Loading";
import { getLaboratoryOrders } from "../../redux/actions/dashboard";
import { getVendorMessages } from "../../redux/actions/messages";
import {
  closeAcceptLabOrderModal,
  closeHomeCareOrderSamplingModal,
  closeLabOrderDirectResultModal,
  closeLabOrderFileResultModal,
  closeLabOrderFinishModal,
  closeLabOrderLinkResultModal,
  closeLabOrderSamplingModal,
  closeOrderSafeCallModal,
  closeRejectLabOrderModal,
} from "../../redux/actions/modals";
import {
  acceptLabOrderEmpty,
  addSamplingDataEmpty,
  getLabOrderCancelReasons,
  makeLabOrderDoneEmpty,
  rejectLabOrderEmpty,
  samplingDoneEmpty,
  sendLabOrderResultEmpty,
} from "../../redux/actions/orders";
import { makeSafeCallEmpty } from "../../redux/actions/safeCall";
import toaster from "../../utils/toaster";
import LabOrdersList from "./components/lab-orders/LabOrdersList";
import MessagesList from "./components/messages/MessagesList";
import AcceptLabOrderComponent from "./components/modals/AcceptLabOrderComponent";
import FinishLabOrderModal from "./components/modals/FinishLabOrderModal";
import HomeCareSamplingComponent from "./components/modals/HomeCareSamplingComponent";
import LabOrderSamplingComponent from "./components/modals/LabOrderSamplingComponent";
import RejectLabOrderComponent from "./components/modals/RejectLabOrderComponent";
import SafeCallModal from "./components/modals/SafeCallModal";
import SendLabDirectResultComponent from "./components/modals/SendLabDirectResultModal";
import SendLabFileResultComponent from "./components/modals/SendLabFileResultModal";
import SendLabLinkResultComponent from "./components/modals/SendLabLinkResultModal";
import TopTiles from "./components/tiles/TopTiles";

const DashboardLab = () => {
  const dispatch = useDispatch();
  const list_empty_message = "موردی جهت نمایش وجود ندارد";
  const { lab_orders_waiting, lab_orders_success, lab_active_tile } =
    useSelector((state) => state.dashboard);
  const { get_vendor_messages_success } = useSelector(
    (state) => state.messages
  );
  const {
    reject_lab_order_success,
    accept_lab_order_success,
    add_sampling_data_success,
    sampling_done_success,
    send_lab_order_result_success,
    sampling_lab_order,
    sampling_home_care_order,
    make_lab_order_done_success,
  } = useSelector((state) => state.orders);
  const { make_safe_call_success } = useSelector((state) => state.safeCall);
  const { general_result_lab_order } = useSelector((state) => state.modals);
  const [tiles, setTiles] = useState([]);
  const [messages, setMessages] = useState([]);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    dispatch(getLaboratoryOrders());
    dispatch(getLabOrderCancelReasons());
    dispatch(getVendorMessages());
    // let interval = setInterval(() => dispatch(getLaboratoryOrders()), 10000);
    return () => {
      // clearInterval(interval);
    };
  }, [dispatch]);
  useEffect(() => {
    if (
      reject_lab_order_success &&
      reject_lab_order_success.result === "SUCCESS"
    ) {
      toaster.success("سفارش مورد نظر با موفقیت رد شد!");
      dispatch(rejectLabOrderEmpty());
      dispatch(closeRejectLabOrderModal());
      dispatch(getLaboratoryOrders());
    }

    if (
      accept_lab_order_success &&
      accept_lab_order_success.result === "SUCCESS"
    ) {
      toaster.success("سفارش مورد نظر با موفقیت تایید شد!");
      dispatch(acceptLabOrderEmpty());
      dispatch(closeAcceptLabOrderModal());
      dispatch(getLaboratoryOrders());
    }

    if (
      add_sampling_data_success &&
      add_sampling_data_success.result === "SUCCESS"
    ) {
      toaster.success("اطلاعات سفارش مورد نظر با موفقیت بروزرسانی شد!");
      dispatch(addSamplingDataEmpty());
      dispatch(closeLabOrderSamplingModal());
      dispatch(closeHomeCareOrderSamplingModal());
      dispatch(getLaboratoryOrders());
    }

    if (sampling_done_success && sampling_done_success.result === "SUCCESS") {
      toaster.success("اطلاعات سفارش مورد نظر با موفقیت بروزرسانی شد!");
      dispatch(samplingDoneEmpty());
      dispatch(getLaboratoryOrders());
    }

    if (
      send_lab_order_result_success &&
      send_lab_order_result_success.result === "SUCCESS"
    ) {
      toaster.success("نتایج سفارش مورد با موفقیت ارسال شد");
      dispatch(sendLabOrderResultEmpty());
      dispatch(closeLabOrderDirectResultModal());
      dispatch(closeLabOrderLinkResultModal());
      dispatch(closeLabOrderFileResultModal());
      dispatch(getLaboratoryOrders());
    }

    if (
      make_lab_order_done_success &&
      make_lab_order_done_success.result === "SUCCESS"
    ) {
      toaster.success("اطلاعات سفارش مورد نظر با موفقیت بروزرسانی شد!");
      dispatch(makeLabOrderDoneEmpty());
      dispatch(closeLabOrderFinishModal());
      dispatch(getLaboratoryOrders());
    }
  }, [
    reject_lab_order_success,
    accept_lab_order_success,
    add_sampling_data_success,
    sampling_done_success,
    send_lab_order_result_success,
    make_lab_order_done_success,
    dispatch,
  ]);

  if (make_safe_call_success && make_safe_call_success.result === "SUCCESS") {
    toaster.success("درخواست تماس امن ارسال شد!");
    dispatch(closeOrderSafeCallModal());
    dispatch(makeSafeCallEmpty());
  }

  useEffect(() => {
    if (
      lab_orders_success.result !== undefined &&
      lab_orders_success.result === "SUCCESS"
    ) {
      setTiles(lab_orders_success.data.tiles);
      let active_orders = lab_orders_success.data.orders.filter((order) => {
        return order.vendor_status === lab_active_tile;
      });
      setOrders(active_orders);
    }
  }, [lab_active_tile, lab_orders_success]);

  useEffect(() => {
    if (
      get_vendor_messages_success.result !== undefined &&
      get_vendor_messages_success.result === "SUCCESS"
    ) {
      setMessages(get_vendor_messages_success.data.messages);
    }
  }, [get_vendor_messages_success]);
  return (
    <>
      <div className="row top-data-holder shadow-sm">
        {messages.length > 0 ? <MessagesList messages={messages} /> : null}
        <TopTiles tiles={tiles} />
      </div>
      <div className="row lab-orders-list-holder">
        {lab_orders_waiting ? (
          <Loading />
        ) : orders.length === 0 ? (
          <ListEmpty message={list_empty_message} />
        ) : (
          <LabOrdersList orders={orders} />
        )}
      </div>
      <RejectLabOrderComponent />
      <AcceptLabOrderComponent />
      <SafeCallModal />
      <SendLabDirectResultComponent order={general_result_lab_order} />
      <SendLabFileResultComponent order={general_result_lab_order} />
      <SendLabLinkResultComponent order={general_result_lab_order} />
      <LabOrderSamplingComponent order={sampling_lab_order} orders={orders} />
      <HomeCareSamplingComponent order={sampling_home_care_order} />
      <FinishLabOrderModal />
    </>
  );
};

export default DashboardLab;
